var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 1.87482C23.6335 1.87482 25.3124 3.55384 25.3125 5.62482V24.3748C25.3125 26.4459 23.6336 28.1248 21.5625 28.1248H8.4375C6.36643 28.1248 4.6875 26.4459 4.6875 24.3748V5.62482C4.68761 3.55384 6.3665 1.87482 8.4375 1.87482H21.5625ZM10.9375 22.491C10.4199 22.491 10.0002 22.911 10 23.4285C10 23.9463 10.4197 24.366 10.9375 24.366H19.375C19.8928 24.366 20.3125 23.9463 20.3125 23.4285C20.3123 22.911 19.8926 22.491 19.375 22.491H10.9375ZM10.9375 18.741C10.4199 18.741 10.0002 19.161 10 19.6785C10 20.1963 10.4197 20.616 10.9375 20.616H19.375C19.8928 20.616 20.3125 20.1963 20.3125 19.6785C20.3123 19.161 19.8926 18.741 19.375 18.741H10.9375ZM15 11.9559C13.2973 11.9559 11.8479 13.0288 11.2939 14.5301C11.1707 14.8646 11.3141 15.2383 11.6299 15.4061C12.6354 15.9392 13.7836 16.241 15 16.241C16.2164 16.241 17.3646 15.9392 18.3701 15.4061C18.6859 15.2383 18.8293 14.8646 18.7061 14.5301C18.1521 13.0288 16.7027 11.9559 15 11.9559ZM15 6.24103C13.811 6.24105 12.8467 7.20113 12.8467 8.38458C12.8468 9.56792 13.8111 10.5271 15 10.5272C16.1889 10.5272 17.1532 9.56793 17.1533 8.38458C17.1533 7.20112 16.189 6.24103 15 6.24103Z",
    fill: "#330075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.a1682a6e3393718288cf245438703542.svg";
export { ForwardRef as ReactComponent };